export const skills = {
    "10001": "衣物製作",
    "10002": "高級閱讀術",
    "10003": "樂器演奏",
    "10004": "休息",
    "10005": "作曲",
    "10006": "音樂知識",
    "10007": "吶喊",
    "10008": "營火",
    "10009": "包紮",
    "10010": "採集",
    "10011": "紡織",
    "10012": "碾磨",
    "10013": "手工藝",
    "10014": "방직 (사용안함)",
    "10015": "冶煉",
    "10016": "打鐵",
    "10020": "料理",
    "10021": "藥草知識",
    "10022": "藥水製作",
    "10023": "釣魚",
    "10024": "精通製作",
    "10025": "打開寶箱",
    "10026": "野生動物訓練",
    "10027": "船槳操縱",
    "10028": "淘金術",
    "10029": "操縱熱氣球",
    "10030": "分解",
    "10031": "合成",
    "10032": "街頭畫家專用技能",
    "10033": "木工",
    "10034": "修整庭園",
    "10036": "製作歌劇任務通行證",
    "10037": "紅酒製造",
    "10039": "研究:藥水中毒",
    "10040": "稀原工學",
    "10041": "魔法製造",
    "10042": "珍奇礦物學",
    "10043": "希里原生態學",
    "10044": "精通料理",
    "10045": "尋找料理",
    "10046": "辦桌料理",
    "10100": "瑪奇魔法陣設計",
    "10101": "瑪奇魔法陣形象化",
    "10102": "瑪奇魔法陣的知識",
    "10103": "瑪奇魔法陣發動",
    "10104": "文具的手工藝",
    "20001": "防禦",
    "20002": "重擊",
    "20003": "反擊",
    "20004": "自然防護",
    "20005": "抵抗",
    "20006": "魔法反射",
    "20007": "迴旋迫擊",
    "20008": "終極重擊",
    "20009": "復仇吟遊詩人",
    "20010": "跳躍",
    "20011": "突擊",
    "20012": "躍擊",
    "20016": "騎槍反擊",
    "20017": "騎槍衝擊",
    "20018": "憤怒衝擊",
    "20019": "猛擊",
    "20020": "終焉斬擊",
    "20021": "蜂擁",
    "20022": "記憶同步",
    "21001": "精通遠距離戰術",
    "21002": "穿心箭",
    "21003": "旋風箭",
    "21004": "旋風箭",
    "21005": "爆裂連擊",
    "21006": "支援箭",
    "21007": "毒雲箭",
    "21008": "點燃炸彈",
    "21009": "精靈弓實體化",
    "21010": "投擲攻擊",
    "21011": "熱氣球弩箭",
    "21012": "蜘蛛網射擊",
    "21013": "熱氣球 弩攻擊 (小遊戲)",
    "21014": "零秒狙擊",
    "21015": "騎槍閃退突刺",
    "21016": "騎槍疾刺",
    "22001": "旋風擺蓮腿",
    "22002": "破碎踏擊",
    "22003": "自爆技能(戰鬥)",
    "22004": "無限斬擊",
    "22005": "精靈劍實體化",
    "22006": "精靈鈍器實體化",
    "22007": "跺腳",
    "22008": "雪怪破碎踏擊",
    "22009": "鱷魚迴旋迫擊",
    "22010": "巨大獅子怒吼",
    "22011": "爆裂箭",
    "23001": "戰鬥反應力",
    "23002": "精通格鬥",
    "23003": "暴擊",
    "23004": "被動自然防護",
    "23005": "被動抵抗",
    "23006": "被動魔法反射",
    "23007": "闇黑之縛技能",
    "23008": "格里斯貝恩技能",
    "23009": "連鎖反應",
    "23010": "自爆",
    "23011": "讀心術技能",
    "23012": "精通劍",
    "23013": "精通斧頭",
    "23014": "精通鈍器",
    "23016": "精通盾牌",
    "23018": "精通重盔甲",
    "23019": "精通輕盔甲",
    "23021": "尾巴攻擊",
    "23022": "石化氣息",
    "23023": "火焰氣息",
    "23024": "龍吻",
    "23025": "巨大沙蟲近戰攻擊",
    "23026": "撕咬",
    "23027": "猛打",
    "23028": "暴風防護",
    "23029": "嘲諷",
    "23030": "終極射擊",
    "23031": "黑暗之息",
    "23032": "黑火",
    "23033": "聖劍之光",
    "23034": "不敗之劍(Claimh Solais)衝擊",
    "23035": "不敗之劍(Claimh Solais) 暴烈猛擊",
    "23036": "稻草人的詛咒",
    "23037": "怒吼",
    "23038": "壁飾火焰",
    "23039": "壁飾冰矛",
    "23040": "壁飾雷矢",
    "23041": "壁飾魔法球攻擊",
    "23042": "壁飾毒氣攻擊",
    "23043": "迴避",
    "23044": "巨蛇石頭遠距離攻擊",
    "23045": "巨蛇石頭近距離攻擊",
    "23046": "巨蛇石頭氣息",
    "23047": "諾亞達破碎踏擊技能",
    "23048": "諾亞達光之矛技能",
    "23049": "諾亞達光之狂怒技能",
    "23050": "諾亞達聖劍之光技能",
    "23051": "諾亞達重擊技能",
    "23052": "狂吼",
    "23053": "死神垂直攻擊",
    "23054": "死神水平攻擊",
    "23055": "死神旋風擺蓮腿",
    "23057": "怒吼",
    "23058": "分身術",
    "23060": "精通弓",
    "23061": "精通弩",
    "23062": "精通騎槍",
    "23063": "精通拳套",
    "23064": "精通雙武器",
    "23101": "勃蘭登堡衝擊波",
    "23102": "勃蘭登堡突擊",
    "23103": "勃蘭登堡揮臂",
    "23104": "搶奪",
    "23105": "逃吧",
    "23106": "金幣攻擊",
    "23107": "狂暴化",
    "23108": "艾維卡的月光",
    "23109": "拉狄卡的氣息",
    "23110": "拉狄卡的視線",
    "23111": "拉狄卡的力量",
    "24001": "精通連續技能",
    "24101": "連續技能: 突拳",
    "24102": "連續技能: 導電拳擊",
    "24103": "連續技能 : 狂暴拳擊",
    "24201": "連續技能: 螺旋勾拳",
    "24202": "連續技能: 翻筋斗",
    "24301": "連續技能: 飛踢",
    "24302": "連續技能: 猛烈突擊",
    "25000": "復原",
    "25001": "後退",
    "26000": "精通手裏劍",
    "26001": "手裏劍突擊",
    "26002": "手裏劍暴風",
    "26003": "影子束縛術",
    "26004": "影子隱身術",
    "26005": "手裏劍爆破",
    "26006": "灰色煙幕術",
    "26007": "櫻花雨",
    "27000": "精通黑闇",
    "27001": "精通鎖鏈鐮刃",
    "27002": "鎖鏈攻擊",
    "27003": "鎖鏈刺擊",
    "27004": "闇夜圓舞曲",
    "27005": "闇夜掠擊",
    "27006": "闇夜處刑",
    "27007": "黑闇掃蕩",
    "27008": "黑闇轉換",
    "27009": "鎖鏈躍疾",
    "27010": "死神烙印",
    "27011": "黑闇解放",
    "27012": "信念解放",
    "27100": "菲尼捕捉",
    "27101": "菲尼綻放",
    "27102": "芬恩同步",
    "27103": "芬恩的手工藝",
    "27104": "芬恩寶珠閃耀",
    "27200": "鐮刀斬擊",
    "27201": "星之引爆",
    "27202": "星界突破",
    "27203": "迴旋斬擊",
    "27204": "星象輪迴",
    "27205": "黃道蔓延",
    "27206": "引力空間",
    "27207": "精通戰鬥占星術",
    "27208": "命運星盤",
    "27209": "命運編織",
    "27210": "星魂卡陣",
    "27211": "星之堡壘",
    "27212": "星辰工藝",
    "27213": "星星垂釣",
    "27214": "卡片神諭",
    "27215": "靈魂捕捉",
    "27216": "靈魂訂製",
    "27217": "貼紙",
    "30003": "冥想",
    "30004": "인챈트 (사용안함)",
    "30005": "魔力賦予",
    "30006": "治癒",
    "30007": "精通魔法",
    "30008": "組隊治癒",
    "30009": "寵物專用冥想",
    "30010": "라이프 드레인 (몬스터용)",
    "30011": "冰鏡魔女休息",
    "30012": "怪物復活",
    "30013": "快速捆綁!",
    "30014": "沉靜瞬移",
    "30015": "誘惑之歌",
    "30016": "精通火魔法",
    "30017": "精通冰魔法",
    "30018": "精通雷魔法",
    "30019": "精通箭系魔法",
    "30022": "魔法武器精通",
    "30101": "雷矢",
    "30102": "雷擊",
    "30103": "浮游石雷擊",
    "30104": "雷擊",
    "30105": "絢麗一擊",
    "30106": "雷氣鎖鏈",
    "30201": "火焰",
    "30202": "火球",
    "30203": "年獸專用火球",
    "30204": "浮游石火焰",
    "30205": "火石狂熱",
    "30301": "冰矛",
    "30302": "冰刃",
    "30303": "icehug",
    "30304": "超級冰矛 (管理者技能)",
    "30305": "噴水",
    "30306": "浮游石冰刃",
    "30307": "雹暴",
    "30401": "精靈魔杖實體化",
    "30450": "雷-冰",
    "30451": "冰-火",
    "30452": "火-雷",
    "30453": "箭系組合魔法",
    "30460": "火之魔法盾",
    "30461": "冰之魔法盾",
    "30462": "雷之魔法盾",
    "30463": "自然魔法盾",
    "30464": "魔力盾牌",
    "30470": "爆裂術",
    "30471": "紙飛機炸彈",
    "30472": "死亡邀請",
    "30473": "地獄火焰",
    "30480": "移動投擲",
    "30481": "導電反應",
    "30482": "聚精凝魔",
    "35001": "魔力凝聚",
    "35002": "吸取生命",
    "35003": "精通鍊金術",
    "35004": "水炮",
    "35005": "結晶 製造",
    "35006": "防護壁",
    "35007": "旋風衝擊",
    "35008": "火焰噴射",
    "35009": "沙暴",
    "35010": "造雨",
    "35011": "冰風暴",
    "35012": "金屬變換",
    "35013": "火花",
    "35014": "高壓火爆",
    "35015": "連鎖鋼瓶",
    "35016": "精通火鍊金術",
    "35017": "精通水鍊金術",
    "35018": "精通土鍊金術",
    "35019": "精通風鍊金術",
    "35021": "精通變換",
    "35022": "元素波動",
    "35023": "黃金時間",
    "35024": "海德拉鍊成",
    "35025": "精通盾牌鋼瓶",
    "35101": "精靈鋼瓶實體化",
    "35111": "精靈單手劍實體化",
    "35112": "精靈單手鈍器實體化",
    "35113": "精靈單手斧實體化",
    "35114": "精靈雙手劍實體化",
    "35115": "精靈雙手鈍器實體化",
    "35116": "精靈雙手斧實體化",
    "35117": "精靈騎槍實體化",
    "35118": "精靈擲矛器實體化",
    "35119": "精靈弓實體化",
    "35120": "精靈弩實體化",
    "35121": "精靈魔杖實體化",
    "35122": "精靈集魔杖實體化",
    "35123": "精靈鋼瓶實體化",
    "35124": "精靈拳套實體化",
    "35125": "精靈手把實體化",
    "35126": "精靈手裏劍實體化",
    "35127": "精靈雙槍實體化",
    "35128": "精靈鎖鏈鐮刃實體化",
    "35129": "精靈大型鐮刀實體化",
    "40001": "神聖之心",
    "40002": "神聖之力",
    "40003": "神聖之眼",
    "40004": "神聖之刃",
    "40011": "聖騎士自然防護",
    "40012": "聖騎士抵抗",
    "40013": "聖騎士魔法反射",
    "41001": "渾沌之心",
    "41002": "闇影操控",
    "41011": "渾沌之體",
    "41012": "渾沌之智",
    "41013": "渾沌之手",
    "41021": "闇黑武士自然防護",
    "41022": "闇黑武士抵抗",
    "41023": "闇黑武士魔法反射",
    "42001": "種族變身",
    "42002": "윈드밀 (사용안함)",
    "43001": "克諾斯之怒",
    "43002": "魔箭迫擊",
    "43011": "克諾斯的防護",
    "43012": "克諾斯之心",
    "43013": "克諾斯的敏銳",
    "43021": "克諾斯自然防護",
    "43022": "克諾斯抵抗",
    "43023": "克諾斯魔法反射",
    "44001": "菲西斯守護者",
    "44002": "暴烈猛擊",
    "44011": "菲西斯防護",
    "44012": "菲西斯的活力泉源",
    "44013": "菲西斯的咒語",
    "44021": "菲西斯自然防護",
    "44022": "菲西斯抵抗",
    "44023": "菲西斯魔法反射",
    "45001": "光之覺醒",
    "45002": "光之矛",
    "45003": "光之狂怒",
    "45004": "光之覺醒",
    "45005": "光之矛",
    "45006": "光之狂怒",
    "45007": "闇影之靈",
    "45008": "翼之蝕",
    "45009": "翼之狂暴",
    "45010": "帕拉魯的光芒",
    "46001": "聖盾庇護",
    "46002": "聖光之錐",
    "46003": "審判之刃",
    "46004": "聖靈同步",
    "46005": "神聖蛻變",
    "46006": "聖靈衝擊",
    "46007": "閃爍",
    "46008": "毀滅之星",
    "50001": "魔力賦予隱藏技能",
    "50002": "復活隱藏技能",
    "50003": "回城隱藏技能",
    "50004": "設置公會石隱藏技能",
    "50005": "蜘蛛絲",
    "50006": "祝福隱藏技能",
    "50007": "營火工具",
    "50008": "技能時空工具",
    "50009": "大型祝福藥水",
    "50010": "染色",
    "50011": "賦予跟蹤元素魔力",
    "50012": "塗抹毒隱藏技能",
    "50013": "描繪",
    "50014": "探測",
    "50015": "炸彈使用隱藏技能",
    "50016": "假死",
    "50017": "隱身",
    "50018": "街頭公演",
    "50019": "地形變化",
    "50020": "扔石頭",
    "50021": "擲骰子",
    "50022": "合奏",
    "50023": "摺紙飛機",
    "50024": "製作巧克力餅乾",
    "50025": "化石復原",
    "50026": "널뛰기",
    "50027": "널뛰기 키트",
    "50029": "巨龍的支援",
    "50030": "冰地雷",
    "50031": "掃描",
    "50032": "巨魔像鍊成",
    "50033": "魔力凝聚 逆使用",
    "50034": "使用支援物品",
    "50035": "使用防止外掛道具",
    "50036": "아이템 봉인",
    "50037": "아이템 봉인 해제",
    "50038": "使用地下城通行證物品",
    "50039": "使用艾爾拉哈物品",
    "50040": "拋花瓣",
    "50041": "放煙火",
    "50042": "吃魚",
    "50043": "打榔頭遊戲",
    "50044": "丟水球",
    "50045": "靈魂移動",
    "50046": "緊急逃脫 B+",
    "50047": "名字顏色變更",
    "50048": "鋼瓶 設置/解除",
    "50049": "聖火",
    "50050": "使用茉麗安的羽毛",
    "50051": "生產法利亞斯魔法門",
    "50052": "聊天顏色變更",
    "50053": "設置個人農場設施",
    "50054": "重配置個人農場的設施",
    "50055": "刷漆",
    "50056": "染料混合",
    "50057": "大陸移動",
    "50058": "再加調味料",
    "50059": "水球攻擊",
    "50060": "緊急逃離冰鎮B",
    "50061": "人偶復活隱藏技能",
    "50063": "使用經驗值分享道具",
    "50064": "合唱",
    "50065": "吹氣球",
    "50066": "團體動作",
    "50067": "玩沙",
    "50068": "完全復活隱藏技能",
    "50069": "擲骰子2",
    "50070": "施放天燈",
    "50071": "施放天燈(隱藏技能)",
    "50072": "設置修理prop",
    "50075": "丟雪",
    "50076": "用力吹氣球",
    "50077": "陪寵物玩",
    "50078": "動物朋友總動員",
    "50079": "聖水",
    "50081": "包含裝備的變身",
    "50082": "格里亞斯形象紀錄",
    "50101": "寵物精煉",
    "50102": "吞食",
    "50103": "發射泡沫",
    "50104": "疾馳",
    "50105": "假死",
    "50106": "主人瞬間移動",
    "50107": "探測",
    "50108": "寵物封印",
    "50109": "隱身",
    "50110": "巨龍流星",
    "50111": "紅色巨龍 火焰氣息",
    "50112": "雷鳴驟雨",
    "50113": "熔岩吞食",
    "50114": "巨龍 怒吼",
    "50115": "瓦伊凡 火焰氣息",
    "50116": "瓦伊凡閃電",
    "50117": "瓦伊凡冰凍氣息",
    "50118": "櫻花工具",
    "50119": "巨龍 支援流星",
    "50120": "旋轉",
    "50121": "眩惑",
    "50122": "浮起來沉下去",
    "50123": "那伊德怒吼",
    "50124": "搖尾巴",
    "50125": "水炸彈",
    "50126": "澆水",
    "50127": "施肥",
    "50128": "除蟲",
    "50129": "旁觀者光線攻擊",
    "50130": "旁觀者警報",
    "50131": "丟斧頭",
    "50132": "大燭臺攻擊",
    "50133": "Death Of Shadow",
    "50134": "合成",
    "50135": "召喚",
    "50136": "雷風暴",
    "50137": "加速器",
    "50138": "雷焰氣息",
    "50139": "火風暴",
    "50140": "火焰氣息",
    "50142": "冰暴",
    "50143": "火焰 躍擊",
    "50144": "疾速衝刺",
    "50145": "열기구 띄우기",
    "50146": "開傘",
    "50147": "아이템 봉인",
    "50149": "구원의 손길",
    "50150": "嚇人",
    "50151": "冰柱風暴",
    "50152": "冰氣息",
    "50153": "普通攻擊",
    "50154": "復活之火",
    "50155": "復活爆發",
    "50156": "鳳凰的煙火",
    "50157": "惡魔的爆走",
    "50158": "石化氣息",
    "50159": "惡魔消滅",
    "50160": "要儲存這個地方嗎?",
    "50161": "要移動到這個地方?",
    "50162": "安息之風",
    "50163": "天馬降臨",
    "50164": "天馬流星踢",
    "50165": "展開翅膀",
    "50166": "引擎衝擊",
    "50167": "服裝動作",
    "50168": "펫 점프",
    "50169": "殭屍的呼喚",
    "50170": "殭屍的漩渦",
    "50171": "殭屍的保護",
    "50172": "浪漫飛行",
    "50173": "飛行",
    "50174": "멀티 물폭탄",
    "50175": "重擊爆裂",
    "50176": "雙足飛龍 冰哮 (小遊戲)",
    "50179": "平靜",
    "50180": "精靈的魔法粉",
    "50181": "治癒的微風",
    "50182": "服裝動作2",
    "50183": "高尚的羊毛",
    "50184": "圖安之魂之歌",
    "50185": "圖安之魂的悄悄話",
    "50186": "圖安之魂的怨恨",
    "50187": "악마의 저주",
    "50188": "酷寒的演奏",
    "50189": "安魂曲",
    "50190": "羅曼蒂克浪漫飛行",
    "50191": "기름 같은 걸 끼얹나?",
    "50192": "很生氣對吧?",
    "50193": "安安! 剩下的就拜託你啦!",
    "50194": "寵物召喚動作用技能",
    "50195": "記得這裡嗎?",
    "50196": "要移動至那裡嗎?",
    "50197": "纏繞的閃電",
    "50198": "龍之怒",
    "50199": "即興演奏",
    "50200": "幫助我, 可可波!",
    "50201": "可可波的一擊",
    "50202": "夥伴治癒",
    "50203": "與我一起跳舞吧",
    "50204": "跟上我的節拍!",
    "50205": "跟上我的節拍! 連續",
    "50206": "地龍的咆哮",
    "50207": "揮動流星錘",
    "50208": "治癒之風",
    "50209": "丟傑克的雪",
    "50210": "傑克的庭院",
    "50211": "迷你兵傑克",
    "50212": "傑克的冰雪平原",
    "50213": "月光浪漫飛行",
    "50214": "不要忘記我",
    "50215": "猛烈攻擊",
    "50216": "雷擊",
    "50217": "雷電交加",
    "50218": "潛入",
    "50219": "魔法光圈",
    "50220": "貓肉球攻擊",
    "50221": "鋒利咆哮",
    "50222": "回憶盛開",
    "50223": "飛翔",
    "50224": "暴走甩尾",
    "50225": "盾牌",
    "50226": "水炸彈投擲",
    "50227": "飛彈攻擊",
    "50228": "卡丁車競速模式",
    "50229": "合音浪漫飛行",
    "50230": "拖拉機衝刺",
    "50231": "歡樂的Japari公園",
    "50232": "到這來!",
    "50233": "惹人愛的行為",
    "50234": "可愛的叫聲",
    "50235": "改變姿勢",
    "50236": "惹人愛的行為",
    "50237": "向上跳",
    "50238": "保護的水波",
    "50239": "水波",
    "50240": "淨化的水波",
    "50241": "飛躍",
    "50242": "午夜浪漫飛行",
    "50243": "華麗的登場",
    "50244": "花哨的舞步",
    "50245": "特別的禮物",
    "50246": "掌聲和喝采",
    "50247": "投擲匕首",
    "50248": "貿易雷龍",
    "50249": "妖精光芒",
    "50250": "聲波氣息",
    "50251": "聲波擺盪",
    "50252": "歌曲感應",
    "50253": "勇猛的和聲",
    "50254": "豐饒的和聲",
    "50255": "疾速的和聲",
    "50256": "花漾浪漫飛行",
    "50257": "喵皇降臨",
    "50258": "喵皇降臨",
    "50259": "肉球領域",
    "50260": "肉球領域",
    "50261": "福喵招來",
    "50262": "改變姿勢",
    "50263": "散步無視",
    "50264": "格拉芙尼爾",
    "50265": "銳利目光",
    "50266": "神秘帷幕",
    "50267": "月之咆哮",
    "50268": "魔杖利爪",
    "50269": "現代浪漫飛行",
    "50270": "友情的秘密問候",
    "50271": "記憶浪漫飛行",
    "50272": "幸運草簽名",
    "50273": "幫我擋住!",
    "50274": "炸開吧!",
    "50275": "請幫幫我!",
    "50276": "打一拳!",
    "50279": "全能鼠鼠種子燃燒",
    "50280": "強化鼠鼠",
    "50281": "迴旋鼠鼠",
    "50282": "鼠者甦醒",
    "50283": "跑輪永動機",
    "50284": "全能鼠鼠種子燃燒",
    "50300": "趴下",
    "50301": "客製化動作",
    "50302": "丟雪",
    "50303": "探查 EX",
    "50304": "營火 EX",
    "50305": "料理 EX",
    "50306": "手工藝 EX",
    "50309": "旋風擺蓮腿 EX",
    "50310": "指揮官技能:召喚隕石",
    "50311": "指揮官技能:封鎖戰場",
    "50312": "指揮官技能:戰場的吶喊",
    "50313": "士兵技能",
    "50400": "水藍之盾",
    "50401": "治癒之光",
    "50402": "紐帶之繩",
    "50403": "暴走的時間",
    "50404": "冰凍的大地",
    "50405": "神速的翅膀",
    "50431": "芙露亞盾牌",
    "50432": "療癒泡泡",
    "50433": "菲尼拳擊",
    "50434": "疾風",
    "50435": "拉力破壞領域",
    "50436": "推力破壞領域",
    "50480": "精通芬恩寵物",
    "50481": "艾許",
    "50482": "索拉",
    "50483": "泰因",
    "50484": "加歐",
    "50485": "塔爾洛",
    "50501": "惡意擴散",
    "50502": "生命擴散",
    "50503": "暴走火車",
    "50504": "聖地巡禮",
    "50505": "白色氣息",
    "50506": "黑色氣息",
    "50507": "地獄魔爪",
    "50508": "惡魔懷抱",
    "50510": "銅牆鐵壁",
    "50511": "結衣的支援攻擊",
    "50512": "유이의 방어지원",
    "50513": "Saber的支援攻擊",
    "50514": "Archer的支援攻擊",
    "50515": "凜的支援攻擊",
    "50516": "伊莉亞的支援攻擊",
    "50517": "帕克的支援攻擊",
    "50518": "藪貓的一擊",
    "50519": "博士的展翅",
    "50520": "助手的展翅",
    "50521": "獰貓的威脅",
    "50522": "著火的紙飛機飛行",
    "50523": "藪貓跳躍",
    "50524": "純真的動作",
    "50525": "冷酷的動作",
    "50526": "駭客姿勢",
    "50527": "水果雜耍",
    "50528": "主唱動作",
    "50650": "設置名稱套用",
    "50651": "地形變化",
    "50700": "旋轉衝擊",
    "50701": "群集爆發",
    "50702": "幻想光圈",
    "51001": "哈姆雷特的苦惱",
    "51002": "克勞迪斯的陰謀",
    "51003": "奧菲莉亞的眼淚",
    "51004": "羅密歐的告白",
    "51005": "提伯爾特的劍術",
    "51006": "茱麗葉的感情",
    "51007": "夏洛克的腳步",
    "51100": "殭屍步伐",
    "51101": "公會旗幟動作1",
    "51102": "公會旗幟動作2",
    "51103": "公會旗幟設置",
    "52000": "梅魯猛烈突擊",
    "52001": "梅魯龍升天",
    "52002": "梅魯大海嘯",
    "52003": "深淵的圈套",
    "52004": "深淵的審判",
    "52005": "深淵的恐怖",
    "52006": "公爵之吻",
    "52007": "公爵的玫瑰",
    "52008": "公爵之霧",
    "52009": "公爵的誘惑",
    "52010": "打雷",
    "52011": "鬼聲",
    "52012": "進擊的飛踢",
    "52013": "進擊的佈局",
    "52014": "進擊的跳躍",
    "52015": "進擊的修繕",
    "52016": "野獸的爆吼",
    "52017": "跳舞時間",
    "52018": "蜘蛛網",
    "52019": "神聖的爆走",
    "52020": "尋找書本",
    "52021": "垂直軸旋轉攻擊",
    "52022": "水準軸旋轉攻擊",
    "52023": "堤安卡特凱爾特刺穿",
    "52024": "堤安卡特凱爾特踐踏",
    "52025": "堤安卡特凱爾特陷阱",
    "52026": "龍形態魯艾利 猛擊",
    "52027": "龍形態魯艾利 攫擊",
    "52028": "龍形態魯艾利 衝刺",
    "52029": "舞杖",
    "52030": "神聖侵蝕",
    "52031": "神聖禁錮",
    "52032": "炙熱",
    "52033": "靈魂吸攝",
    "52034": "殞石流星雨",
    "52035": "艾爾班埋伏攻擊",
    "52036": "艾爾班冰噴射",
    "52037": "艾爾班箭雨",
    "52038": "痛苦的空間",
    "52039": "蝴蝶效應",
    "52040": "引火自焚",
    "52041": "甜蜜幻象",
    "52042": "王女之怒火",
    "52043": "附身術",
    "52044": "遊魂怒吼",
    "52045": "變成石像",
    "52046": "閃耀之星!",
    "52047": "全身感應",
    "52048": "分開支配",
    "52049": "凝視",
    "52050": "冤魂的力量",
    "52051": "負面的力量",
    "52052": "爆走的力量",
    "52053": "遠征",
    "52054": "水柱噴射",
    "52055": "巨龜蜷縮",
    "52056": "滾石掠擊",
    "52057": "狂野之姿",
    "52058": "水之療癒",
    "52059": "巨龜龍吻",
    "52060": "痛苦音波",
    "52061": "銳利之風",
    "52062": "重擊",
    "52063": "重力破碎踏擊",
    "52064": "劇毒氣息",
    "52065": "巨石衝擊",
    "52066": "狂野嘶吼",
    "52067": "爆水水滴",
    "52068": "挖掘墳墓",
    "52069": "舞動雙刃劍",
    "52070": "猛烈的突擊",
    "52071": "礦物爆炸",
    "52072": "靈魂的追擊",
    "52073": "煉獄",
    "52074": "痛苦的試煉",
    "52075": "獅子吼",
    "52076": "召喚生魂",
    "52077": "暴風之刃",
    "52078": "碎石",
    "52079": "守護者之力",
    "52080": "啟示的證據",
    "52081": "審判之雨",
    "52082": "蒂亞卡垂直攻擊",
    "52083": "蒂亞卡水平攻擊",
    "52084": "蒂亞卡旋風擺蓮腿",
    "52085": "熔岩光圈生成",
    "52086": "鐵鍊突擊",
    "52087": "破壞者",
    "52088": "火柱召喚",
    "52089": "分身吸收",
    "52090": "旋風重擊",
    "52091": "殲滅之光",
    "52092": "破壞之光",
    "52093": "石化爆發",
    "52094": "黑色爆發",
    "52095": "熔岩光圈隨機生成",
    "52096": "黑魔彈",
    "52097": "死神召喚",
    "52098": "集魔杖召喚",
    "52099": "湧出的水",
    "52100": "暴風雨",
    "52101": "延伸的閃電",
    "52102": "水柱",
    "52103": "蠶食",
    "52104": "感染",
    "52105": "幻象",
    "52106": "尖刺飛舞",
    "52107": "全體墨汁",
    "52108": "觸角湧出",
    "52109": "捶打地板",
    "52110": "勒緊(死亡為止)",
    "52111": "勒緊(自爆為止)",
    "52112": "觸角自爆",
    "52113": "觸角揮掃",
    "52114": "鬼魂",
    "52115": "艦砲射擊",
    "52116": "基本攻擊",
    "52117": "科隆克斯亞的氣息",
    "52118": "前腳攻擊",
    "52119": "用身體頂撞",
    "52120": "科隆克斯亞火石",
    "52121": "迴轉頂撞",
    "52122": "惡夢",
    "52123": "黑暗刺擊",
    "52124": "月石落下",
    "52125": "花樣步伐",
    "52126": "費德舞步",
    "52127": "死亡的氣味",
    "52128": "黃昏的光芒",
    "52129": "強震",
    "52130": "競技者",
    "52131": "of",
    "52133": "奈克拉維頂撞",
    "52134": "奈克拉維鯨魚跳躍",
    "52135": "奈克拉維聲波",
    "52136": "奈克拉維擺尾",
    "52137": "奈克拉維逃跑",
    "52138": "海米斯黑洞",
    "52139": "海米斯的悄悄話",
    "52140": "貝仁刺殺",
    "52141": "貝仁擊倒",
    "52142": "召喚巴羅爾",
    "52143": "猛烈地打擊",
    "52144": "腐敗的仇恨",
    "52145": "大地衝擊",
    "52146": "凝聚的力量",
    "52147": "厭惡的塊狀物",
    "52148": "受到詛咒的浮游物",
    "52149": "利爪",
    "52150": "惡魔之光",
    "52151": "黑暗魚鉤",
    "52152": "跳躍衝刺",
    "52153": "連續追加攻擊",
    "52154": "劍刃暴風",
    "52155": "爾格光束",
    "52156": "爾格光束360度",
    "52157": "爾格黑洞",
    "52158": "格里斯貝恩混亂",
    "52159": "馬爾康炸彈",
    "52160": "神的庇護",
    "52161": "集中增益",
    "52162": "衝擊波",
    "52163": "圓陣毀滅",
    "52164": "腐蝕的月光",
    "52165": "轉移的死亡",
    "52166": "大軍之力",
    "52167": "蜜糖炸彈",
    "52168": "卡莉亞赫寒氣火花",
    "52169": "卡莉亞赫冰霜衝擊",
    "52170": "卡莉亞赫裂痕",
    "52171": "卡莉亞赫燃燒的大地",
    "52172": "卡莉亞赫死亡來臨",
    "52173": "卡莉亞赫收集靈魂",
    "52174": "卡莉亞赫注入靈魂",
    "52175": "卡莉亞赫時間逆轉",
    "52176": "卡莉亞赫時間回歸",
    "52177": "卡莉亞赫三連擊",
    "52178": "卡莉亞赫旋轉分割",
    "52179": "卡莉亞赫冰箭",
    "52180": "卡莉亞赫破壞光線",
    "52181": "卡莉亞赫時間分裂",
    "52182": "卡莉亞赫連續投擲",
    "52183": "卡莉亞赫末日宣告",
    "52184": "卡莉亞赫酷寒的時間",
    "52185": "克羅克冰擊",
    "52186": "卡莉亞赫落下的冰角",
    "52187": "卡莉亞赫寒冬的密語",
    "52188": "追蹤寒冬的密語",
    "52200": "霜角鹿突進",
    "52201": "自爆",
    "52202": "冰之加特林",
    "52203": "滾輪攻擊",
    "52204": "咆嘯",
    "52205": "冬眠",
    "52206": "憤怒的咆哮",
    "52207": "丟雪球",
    "52208": "撕咬",
    "52209": "無影攻擊技能",
    "52210": "雷擊",
    "52211": "奇襲",
    "52212": "反擊",
    "52213": "崩潰",
    "52214": "推開普麗雅",
    "52215": "普麗雅羽毛暴擊",
    "52216": "普麗雅旋風",
    "52217": "普麗雅憤怒",
    "52218": "普麗雅烏鴉光束",
    "52219": "發動: 閃光",
    "52220": "命令: 暴風",
    "52221": "懲戒: 審判",
    "52222": "碎裂之臂",
    "52223": "電力螺旋",
    "52224": "轟烈暴擊",
    "52225": "鋼鐵衝擊:右",
    "52226": "鋼鐵衝擊:左",
    "52227": "展開: 迴旋",
    "52300": "眼下的舞蹈",
    "52301": "拂過田野的風",
    "52302": "重逢:格鬥",
    "52303": "風蝕",
    "52304": "沉澱",
    "52305": "沉浸的視野",
    "52306": "各個擊破",
    "52307": "重逢:近距離戰鬥",
    "52308": "連續指定",
    "52350": "大地的呼喚",
    "52351": "大地的迴響",
    "52352": "狂飆突擊(左側)",
    "52353": "狂飆突擊(右側)",
    "52354": "裂地憤怒(左側)",
    "52355": "裂地憤怒(右側)",
    "52356": "融入大地的氣息",
    "52357": "融入大地的強大氣息",
    "52358": "暴風狂奔",
    "52359": "俯衝攻擊",
    "52360": "憤怒狂奔",
    "52361": "破風狂奔",
    "52362": "末日漩渦",
    "52400": "神彈",
    "52401": "神劍",
    "52402": "神槍",
    "52403": "信任暴風",
    "52404": "神之降臨",
    "52405": "恩典之後",
    "52406": "上帝之翼",
    "52407": "籠罩之神的奇蹟",
    "52408": "召喚安樂的碎片",
    "52409": "博愛的團結",
    "52410": "純愛的壁壘",
    "52411": "偏袒的行跡",
    "52412": "愛恨的審判",
    "52413": "天譴",
    "52414": "分裂的衝突",
    "52415": "羽毛紛飛",
    "52416": "羽毛的舞道",
    "52417": "永劫的審判",
    "52500": "射!",
    "52501": "尾巴地下城炸彈",
    "52502": "凍結的咆哮",
    "52503": "荊棘之光",
    "52504": "玫瑰低語",
    "53001": "旋律衝擊",
    "53002": "安可",
    "53003": "幻想的合唱",
    "53101": "戰場的序曲",
    "53102": "搖籃曲",
    "53103": "活潑板",
    "53104": "忍耐的音樂",
    "53105": "豐年歌",
    "53106": "進行曲",
    "53107": "死亡之舞",
    "53200": "歌唱",
    "54001": "人偶操縱術",
    "54081": "小丑人偶",
    "54082": "巨像人偶",
    "54101": "第二幕 : 激增的憤怒",
    "54102": "第一幕 : 偶然的衝突",
    "54103": "第四幕 : 嫉妒的化身",
    "54104": "第六幕 : 誘惑的圈套",
    "54105": "第七幕 : 狂亂的奔走",
    "54106": "第九幕 : 甦醒的生命",
    "54151": "第二幕 : 激增的憤怒AI",
    "54152": "第一幕 : 偶然的衝突AI",
    "54153": "第四幕 : 嫉妒的化身AI",
    "54154": "第六幕 : 誘惑的圈套AI",
    "54155": "第七幕 : 狂亂的奔走AI",
    "54156": "第九幕 : 甦醒的生命AI",
    "54201": "幕後操作",
    "54202": "幕前魁儡",
    "54302": "精通雙槍",
    "54303": "十字槍擊",
    "54304": "拉近",
    "54305": "退遠",
    "54306": "衝射",
    "54307": "彈雨",
    "54401": "裝彈",
    "54402": "雙槍射擊",
    "55001": "剪羊毛",
    "55002": "採礦",
    "55003": "蒐集雞蛋",
    "55004": "採集香菇",
    "55005": "擠牛奶",
    "55006": "秋收",
    "55007": "鋤田",
    "55100": "精通交易",
    "56001": "精通變身",
    "57001": "精通冒險",
    "57002": "遺物調查",
    "57003": "逃脫危機",
    "57004": "獎金 地下城 探索",
    "57005": "伊利亞探險隊被動",
    "58000": "堅定意志",
    "58001": "超越:生命",
    "58002": "衝擊相消",
    "58003": "傷害吸收",
    "58004": "起死回生",
    "58005": "時間歪曲",
    "58006": "快速",
    "58007": "要害貫通",
    "58008": "元素打磨",
    "58009": "連續攻擊",
    "58010": "洞察之眼",
    "58011": "狀態支援",
    "58012": "集中引誘",
    "58013": "再生之域",
    "58014": "力量團聚",
    "58015": "連續實體化",
    "58016": "阻斷",
    "58017": "保護之手",
    "58018": "刻印 : 弗拉加拉赫",
    "58100": "爆破",
    "58101": "閃焰",
    "58102": "疾風",
    "58103": "追逐者",
    "58104": "籠罩",
    "58200": "守護的氣勢",
    "58201": "湧入的氣息",
    "58202": "寬容的祝福",
    "59000": "治癒之手",
    "59001": "救贖的迴聲",
    "59002": "活力之聲",
    "59003": "和諧小舞曲",
    "59004": "淨化的鼓動",
    "59005": "崩壞的波動",
    "59006": "守護的祝福",
    "59007": "甦醒的讚歌",
    "59008": "和諧的旋律",
    "59020": "注魔:火焰",
    "59021": "注魔:冰晶",
    "59022": "注魔:閃電",
    "59023": "高級防禦",
    "59024": "火焰躍擊",
    "59025": "寒冰旋風",
    "59026": "閃電雷擊",
    "59027": "注魔",
    "59028": "破陣突圍",
    "59040": "龍焰",
    "59041": "暗雷連結",
    "59042": "寒冰送葬",
    "59043": "屬性轉換:魔力",
    "59044": "屬性轉換:黑闇值",
    "59045": "魔力封鎖",
    "59046": "魔力穿刺",
    "59060": "爆炎箭",
    "59061": "流水射擊",
    "59062": "界線之力",
    "59063": "霰彈射擊",
    "59064": "三重極限",
    "59065": "鍊金加成",
    "59080": "聖域展開",
    "59081": "零秒嘲諷",
    "59082": "盾擊衝鋒",
    "59083": "盾崩強襲",
    "59084": "審判重擊",
    "59085": "犧牲懲戒",
    "59086": "榮光獻身",
    "59100": "護盾轉移",
    "59101": "專注之刃",
    "59102": "衝擊粉碎",
    "59103": "旋渦風暴",
    "59104": "衝鋒突擊",
    "59105": "超載爆發",
    "59106": "湮滅一槍",
    "59120": "迅捷連射",
    "59121": "重裝武力",
    "59122": "毀滅砲擊",
    "59123": "死亡準星",
    "59124": "槍手之眼",
    "59125": "轉化領域",
    "59126": "鍊合轉換",
    "59140": "元素組合",
    "59141": "觸媒效應",
    "59142": "屬性共鳴",
    "59143": "召喚噩夢",
    "59144": "化學狂歡",
    "59145": "地裂螺旋",
    "60000": "誓約勝利之劍",
    "60001": "風王結界",
    "60002": "無限劍製",
    "60003": "偽 螺旋劍",
    "60004": "天地乖離開闢之星",
    "60005": "王之財寶",
    "60006": "十二試煉",
    "60007": "迴旋斬",
    "65001": "拿物品(GM技能)",
    "65002": "超級旋風擺蓮腿(GM技能)",
    "65003": "編輯地圖（管理者技能）",
    "65004": "다 죽이기 (운영자 스킬)",
    "65005": "혼자 죽기 (운영자 스킬)",
    "65006": "撿起物品2 (營運者技能)",
    "65007": "슈퍼 올가미 (운영자 스킬)",
};
